import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler,
    Keyboard,
    ActivityIndicator
} from "react-native";
import HMActionBar from "../../../../../customviews/HMActionBar";
import {serviceActionListNotSendMyApply} from "../../../splash/action/ActionSplashGetAllData";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import i18n from '../../../../../I18n/i18n.js';
import {moderateScale} from "../../../../../tools/Scaling";
//import {Card, CardItem, CheckBox, Content, Icon, Input, Item} from "native-base";

import HMTextInput from "../../../../../customviews/HMTextInput";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import * as NavigationService from "../../../../../redux/NavigationService";
// import Modal from "react-native-modal";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import store from "../../../../../redux/store/index";
import {typeExport} from "../../../../../redux/store/type";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import moment from "moment-jalaali";

moment.locale("fa");
moment.loadPersian();
let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;
let content = null;
import axios from "axios";
//import Sound from "react-native-sound";
import ShowMap from "../../../../common/map/ShowMap";
import HMItemCategory from "../../../../../customviews/HMItemCategory";
import HMFiles from "../../../../../customviews/file/HMFiles";
import Steps from "../../../../../customviews/steps/Steps";
import HMAlert from "../../../../../customviews/HMAlert";
import PathFile from "../../../../../assets/PathFile/index";
import HMFilesTest from "../../../../../customviews/file/HMFilesTest";

const firstIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 4,
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 15,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: 12,
    currentStepLabelColor: '#4aae4f',
};

//var sound = null
var CountSteps = null
//Sound.setCategory('Playback');
export default class SubmitRequestScreen22 extends Component {

    constructor(props) {
        super(props);
        container = this;
        //let {token} = store.getState().reducerSplashGetAllData
        let _params = this.props.route.params;
        let item = JSON.parse(_params.item);
        let data = JSON.parse(_params.data);
        let position = JSON.parse(_params.position);
        // let {item} = props.route.params;
        CountSteps = item.type == 10 ? 4 : 5;

        //   let arr = store.getState().reducerSplashGetAllData.resultsSaina.result.subject;
        let resultsSaina = store.getState().reducerSplashGetAllData.resultsSaina;
        let resultsShahrdar = store.getState().reducerSplashGetAllData.resultsShahrdar;
        let list = item && item.subjects ? item.subjects : (resultsSaina ? resultsSaina.result.list : resultsShahrdar.result.subjects);
        let arr = [];
        if (data && data.subjects) {
            arr = data.subjects;
        }
        else {
            arr = list;
            if (resultsSaina) {
                arr = arr.find(({type}) => type == item.type);
                arr = (arr && arr !== null ? arr.subjects : (list && list.length > 0 ? list[0].subjects : []))
            }
        }


        let indexSelectedArray1 = -1;
        let itemSelectedArray1 = null;

        let itemSelectedArray1Sub = null;
        let indexSelectedArray1Sub = -1;
        if (item.type == 10 && arr.length > 0) {

            let indexSelect = arr.findIndex(({id}) => id == item.subg_id);
            let result = arr.find(({id}) => id == item.subg_id);
            let result_list = []
            result_list.push(result);
            arr = result_list;
            let listChild = []

            if (indexSelect !== -1) {
                listChild = arr[indexSelect].subjects;

                indexSelectedArray1 = indexSelect;
                itemSelectedArray1 = arr[indexSelect];

                /*       let indexSelectChild = listChild.findIndex(({subjectsid}) => subjectsid == item.sub_id);

                       if (indexSelectChild !== -1) {
                           indexSelectedArray1Sub = indexSelectChild;
                           itemSelectedArray1Sub = listChild[indexSelectChild];

                       }*/
            }

        }

        content = this;
        //    let listMenus=  store.getState().reducerSplashGetAllData.resultsSaina.result.list.find(({type}) => type == this.props.route.params.item.type).subjects;
        let listMenus = arr;
        let listPlace = resultsSaina ? resultsSaina.result.places : resultsShahrdar.result.places;
        let {addressMap} = props.route.params


        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        let my_position = store.getState().reducerSplashGetAllData.Location;
        let {reducerSplashGetAllData} = store.getState();
        let {latitude, longitude} = reducerSplashGetAllData.resultsSaina ? reducerSplashGetAllData.resultsSaina.result.info : reducerSplashGetAllData.resultsShahrdar.result.info
        this.state = {

            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,

            currentPage: 0,

            indexSelectedArray1: indexSelectedArray1,
            itemSelectedArray1: itemSelectedArray1,

            itemSelectedArray1Sub: itemSelectedArray1Sub,
            indexSelectedArray1Sub: indexSelectedArray1Sub,

            indexSelectedArray2: -1,
            itemSelectedArray2: null,


            indexSelectedArray2Sub: -1,
            itemSelectedArray2Sub: null,


            pageDataArray1Sub: [],
            pageDataArray2: [],
            pageDataArray2Sub: [],
            typeButton: "next",
            name: '',
            description: '',
            arrData: [],
            listName: [],


            modalHeight: 0,

            dataSourcearraycategory: arr,
            categoryInput: null,
            arraycategory: arr,
            Category: {id: 0, value: i18n.t('constant.selectCategory')},

            arrayCategoryType: [],
            categoryTypeInput: null,
            dataSourcearrayCategoryType: [],
            CategoryType: {id: 0, value: i18n.t('constant.selectCategoryType')},

            //   arrayBedrooms: props.DataSplashScreen.results.bedrooms,
            textarrayBedrooms: null,
            dataSourcearrayBedrooms: [],
            bedrooms: {id: 0, value: i18n.t('constant.selectBedrooms')},


            address: addressMap,
            desc: null,


            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: false,
            ShowVideo: false,
            ShowAudio: false,

            pathImage: null,
            pathImageVideo: null,
            pathVideo: null,

            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            // audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            // long: props.route.params.position ? props.route.params.position.longitude : (location ? location.coords.longitude : null),
            // lat: props.route.params.position ? props.route.params.position.latitude : (location ? location.coords.latitude : null),
            long: position && position.coords ? position.coords.longitude : (my_position ? my_position.coords.longitude : longitude),
            lat: position && position.coords ? position.coords.latitude : (my_position ? my_position.coords.latitude : latitude),


            listMenu: [],
            listSearch: [],

            arrImage: [],
            alaki: false
        }
        //this.pageDataArray = ['انتخاب محل', 'گروه موضوع', 'زیر گروه', 'ضمیمه فایل', 'درج توضیحات'];
        this.pageDataArray = ['', '', '', '', ''];
        //  arr.find(({type}) => type == item.type)
        //type=0 => category ,type=1 => not category ,
        this.pageDataArray1 = listMenus
        this.pageDataArray2 = listPlace
        props.callserviceActionRefresh()


    }

    SearchFilterFunction(data, text) {


        const newData = data.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.subjects_tks_subject.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })

        this.setState({
                listSearch: text && text.length > 0 ? newData : [],

            },
            () => {

            })
    }

    selectListInFlatlist(index) {
        let d = null


        switch (index) {
            case 0:

                d = this.pageDataArray1

                this.nextEmpty(d, this.state.indexSelectedArray1)

                return d

            case 1:
                //Keyboard.dismiss()
                d = this.pageDataArray1[this.state.indexSelectedArray1].subjects
                this.nextEmpty(d, this.state.indexSelectedArray1Sub)
                return d

            /*      case 2:
                      d = this.pageDataArray2
                      this.nextEmpty(d, this.state.indexSelectedArray2)
                      return d


                  case 3:

                      // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                      return d*/

            default:
                return []

        }
    }

    goToIndex(index) {
        if (content.list && index >= 0)
            setTimeout(function () {


                try {
                    if (content.list && index >= 0)
                        content.list.scrollToIndex({animated: true, index: index});

                } catch (e) {
                    console.error(e)
                }

            }, 100)

    }

    nextEmpty(data, index) {

        if (data && data.length > 0) {

            this.goToIndex(index, data)
        } else {
            this.setState({
                    currentPage: this.state.typeButton === "next" ? this.state.currentPage + 1 : this.state.currentPage - 1
                },
                () => {

                })
        }

    }


    selectTick(index) {
        switch (container.state.currentPage) {
            case 1:

                return container.state.indexSelectedArray1 == index

            case 2:

                return container.state.indexSelectedArray1Sub == index
            case 3:

                return container.state.indexSelectedArray2 == index

            case 4:


                return container.state.indexSelectedArray2Sub == index

        }
    }


    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }


    async componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
///////////////////////audio///////////////////////////////
        //  this.prepareRecording()


        this.setState({
            dataSourcearraycategory: this.state.arraycategory,
        })
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);

    }


////////////////////////////////////audio///////////////////////////////
    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
        /*  if (sound) {
              sound.release();
              sound = null;
          }*/
        if (this.timeout) {
            clearInterval(this.timeout);
        }
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (this.state.currentPage >= 1) {

            let page = this.state.currentPage
            this.setState({
                    listMenu: []
                },
                () => {
                    this.setState({
                            listMenu: page == 2 ? this.pageDataArray1 : (page == 3 ? this.pageDataArray1[this.state.indexSelectedArray1].subjects : []),
                            currentPage: page - 1, typeButton: "back",
                            listSearch: [],
                            textInputSearch: '',
                        }
                        , () => {
                            let d = null;
                            switch (page) {
                                case 2:

                                    d = this.pageDataArray1

                                    this.nextEmpty(d, this.state.indexSelectedArray1)

                                    break;

                                case 3:
                                    //Keyboard.dismiss()
                                    d = this.pageDataArray1[this.state.indexSelectedArray1].subjects
                                    this.nextEmpty(d, this.state.indexSelectedArray1Sub)
                                    break;

                                // case 3:
                                //     d = this.pageDataArray2
                                //     this.nextEmpty(d, this.state.indexSelectedArray2)
                                //     return d
                                //
                                //
                                // case 4:
                                //
                                //     // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                                //     d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                                //     this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                                //     return d

                                default :
                            }
                            //this.selectListInFlatlist(page)
                        }
                    )
                }
            )


        } else {
            this.props.navigation.pop()
            //NavigationService.Pop();
        }
    }


    goNext(item, index) {
        let selectItem = "selectItem_" + index
        let selectIndex = "selectIndex_" + index
        let d = [];
        let page = container.state.currentPage

        switch (page) {
            case 0:
                d = container.pageDataArray1
                container.setState({
                        listMenu: [],
                    },
                    () => {
                        container.setState(prevState => ({
                                listMenu: d,
                                typeButton: "next",
                                currentPage: page + 1
                            }),
                            () => {

                                // container.nextEmpty(d, container.state.indexSelectedArray1Sub);

                                // let r = "ref_Image"
                                // setTimeout(function () {
                                //
                                //     try {
                                //         if (content.list && index >= 0)
                                //             content.list.scrollToIndex({
                                //                 animated: true,
                                //                 index: Platform.OS === 'android' ? 0 : 0
                                //             })
                                //
                                //     } catch (e) {
                                //         console.error(e)
                                //
                                //     }
                                //
                                //     // alert("df")
                                // }, 500)


                                //  content.list.scrollToIndex(item)
                                // this[r].measureLayout(
                                //  container.list.measureLayout(
                                //      ReactNative.findNodeHandle(container._scroll),
                                //      (x, y) => {
                                //          container._scroll.scrollTo({
                                //              x: 0,
                                //              y: y - moderateScale(40),
                                //              animated: true
                                //          });
                                //      }
                                //  );

                                //   container.setState({currentPage: page + 1})
                                //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                            }
                        )
                    }
                );
                break;
            case 1:
                d = container.pageDataArray1[index].subjects
                container.setState({
                        listMenu: [],
                    },
                    () => {
                        container.setState(prevState => ({
                                listMenu: d,
                                [selectItem]: item,
                                [selectIndex]: index,
                                indexSelectedArray1: index,
                                itemSelectedArray1: item,

                                itemSelectedArray1Sub: null,
                                indexSelectedArray1Sub: -1,
                                // itemSelectedArray1Sub: item.subjects[0],
                                // indexSelectedArray1Sub: 0,
                                typeButton: "next",
                                currentPage: page + 1
                                //pageDataArray1Sub:container.pageDataArray1[index]
                                // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                            }),
                            () => {

                                //  container.nextEmpty(d, container.state.indexSelectedArray1Sub);

                                // let r = "ref_Image"
                                // setTimeout(function () {
                                //
                                //     try {
                                //         if (content.list && index >= 0)
                                //             content.list.scrollToIndex({
                                //                 animated: true,
                                //                 index: Platform.OS === 'android' ? 0 : 0
                                //             })
                                //
                                //     } catch (e) {
                                //         console.error(e)
                                //
                                //     }
                                //
                                //     // alert("df")
                                // }, 500)
                                //  content.list.scrollToIndex(item)
                                // this[r].measureLayout(
                                //  container.list.measureLayout(
                                //      ReactNative.findNodeHandle(container._scroll),
                                //      (x, y) => {
                                //          container._scroll.scrollTo({
                                //              x: 0,
                                //              y: y - moderateScale(40),
                                //              animated: true
                                //          });
                                //      }
                                //  );

                                //   container.setState({currentPage: page + 1})
                                //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                            }
                        )
                    }
                );

                break;

            case 2:
                container.setState(prevState => ({
                        listMenu: [],
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1Sub: index,
                        itemSelectedArray1Sub: item,
                        typeButton: "next"
                        //  pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: page + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

//             case 3:
//
//                 container.setState(prevState => ({
//                         [selectItem]: item,
//                         [selectIndex]: index,
//                         indexSelectedArray2: index,
//                         itemSelectedArray2: item,
//
//                         itemSelectedArray2Sub: null,
//                         indexSelectedArray2Sub: -1,
//                         // itemSelectedArray1Sub: item.subjects[0],
//                         // indexSelectedArray1Sub: 0,
//                         typeButton: "next",
//                         currentPage: page + 1
//                         //pageDataArray1Sub:container.pageDataArray1[index]
//                         // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
//                     }),
//                     () => {
//
//
//                         let r = "ref_Image"
//                         setTimeout(function () {
//
//                             try {
//                                 content.list.scrollToIndex({
//                                     animated: true,
//                                     index: Platform.OS === 'android' ? 0 : 0
//                                 })
//
//                             } catch (e) {
//                console.error(e)
//                             }
//
//                             // alert("df")
//                         }, 500)
//                         //  content.list.scrollToIndex(item)
//                         // this[r].measureLayout(
//                         //  container.list.measureLayout(
//                         //      ReactNative.findNodeHandle(container._scroll),
//                         //      (x, y) => {
//                         //          container._scroll.scrollTo({
//                         //              x: 0,
//                         //              y: y - moderateScale(40),
//                         //              animated: true
//                         //          });
//                         //      }
//                         //  );
//
//                         //   container.setState({currentPage: page + 1})
//                         //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
// //
//                     }
//                 )
//                 break;
//
//             case 4:
//                 container.setState(prevState => ({
//                         [selectItem]: item,
//                         [selectIndex]: index,
//                         indexSelectedArray2Sub: index,
//                         itemSelectedArray2Sub: item,
//                         typeButton: "next"
//                         //  pageDataArray1Sub:container.pageDataArray1[index]
//                         // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
//                     }),
//                     () => {
//
//                         container.setState({currentPage: page + 1})
//                         //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
// //
//                     }
//                 )
//                 break;

        }
    }

    handleScroll(event) {
    }

    _onRef = (property, view) => {
        this[property] = view
    }

    render() {
        let textButtonNext = this.state.currentPage === CountSteps - 1 ? i18n.t('constant.SubmitRequest') : i18n.t('constant.next')
        // let dataList = this.selectListInFlatlist(this.state.currentPage)
        let dataList = this.state.listMenu ? this.state.listMenu : [];
        let {typeComponent} = this.props.route.params
        let _params = this.props.route.params;
        let item = JSON.parse(_params.item);
        let position = JSON.parse(_params.position);
        let optional = (Platform.OS === 'ios' ? {
            //compressImageMaxWidth: Platform.OS==='ios'?10000:1000,
            //  compressImageMaxHeight: Platform.OS==='ios'?10000:1000,
            enableRotationGesture: true,
            // cropping: true,
            compressImageQuality: .5
        } : {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            cropping: true,
            // compressImageQuality:.5
        });
        return (
            <View style={{flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        <HMActionBar

                            menu={!typeComponent}
                            props={this.props} statusBarTransparent
                            // text={i18n.t('Privatizations.title')}
                            text={item.type == 10 && this.state.currentPage === 0 ? "آدرس محل زندگی خود را انتخاب نماید" : i18n.t('constant.SubmitRequest')}
                            headerVisibility
                            more_menu
                            back
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        <View

                            style={styles.stepIndicator}>

                            <Steps
                                configs={firstIndicatorConfigs}
                                current={this.state.currentPage}
                                // reversed={true}
                                //  labels={this.pageDataArray}

                                count={CountSteps}
                            />
                        </View>


                        <View ref={(ref) => {
                            this.contView = ref;
                        }} style={{flex: 1}}>

                            <View style={{flex: 1}}>

                                {
                                    dataList && dataList.length > 0 && this.state.currentPage < CountSteps - 2 ?
                                        <View
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                //top: 0,
                                                marginTop: moderateScale(4),
                                                alignItems: 'center',
                                                //backgroundColor:'#ee036b',
                                                // flex: 1,
                                                zIndex: 999,

                                            }}
                                        >


                                            <View
                                                style={{
                                                    width: "96%",
                                                    //  width: typeExport.WIDTH ,
                                                    height: moderateScale(44),
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(6),


                                                    //  marginHorizontal:moderateScale(6)
                                                    //   marginStart: moderateScale(43),

                                                }}

                                                onPress={() => {
                                                    this.setState({
                                                        visibleModal: 'Modal'
                                                    })
                                                }}
                                            >
                                                <View style={{flex: 1}}>
                                                    {

                                                        <HMTextInput
                                                            voice
                                                            value={this.state.textInputSearch}
                                                            //keyboardType="numeric"
                                                            onChangeText={(text) => this.setState({textInputSearch: text}, () => {
                                                                this.SearchFilterFunction(dataList, text)

                                                            })}
                                                            // autoFocus
                                                            placeholder={i18n.t('constant.Search')}
                                                            NoShowPlaceholder

                                                            style={{
                                                                fontSize: moderateScale(14),
                                                            }} underlineColorAndroid="transparent"
                                                        />


                                                    }


                                                </View>


                                            </View>


                                        </View>
                                        :
                                        null

                                }
                                {
                                    dataList && dataList.length > 0 ?
                                        <View style={{flex: 1}}>

                                            <FlatList
                                                // getItemLayout={(data, index) => {
                                                //     return {length: 33, index, offset: 33 * index}
                                                // }}

                                                ref={(ref) => {
                                                    this.list = ref;
                                                }}
                                                onScroll={(e) => this.handleScroll(e)}
                                                // scrollEnabled={false}
                                                //      numColumns={3}
                                                //       data={this.pageDataArray1}
                                                //data={dataList}
                                                data={this.state.listMenu}
                                                // data={this.selectListInFlatlist(this.state.currentPage)}
                                                keyExtractor={(item, index) => item.image}
                                                //  onScrollToIndexFailed={()=>{}}

                                                /*        numColumns={this.state.columnCount}
                                                        key={this.state.columnCount}*/
                                                onScrollToIndexFailed={(error) => {
                                                    this.list.scrollToOffset({
                                                        offset: error.averageItemLength * error.index,
                                                        animated: true
                                                    });
                                                    setTimeout(() => {
                                                        if (this.state.listMenu.length !== 0 && this.list !== null) {
                                                            this.list.scrollToIndex({
                                                                index: error.index,
                                                                animated: true
                                                            });
                                                        }
                                                    }, 100);
                                                }}
                                                renderItem={({item, index}) => {
                                                    return <HMItemCategory
                                                        selectTick={container.selectTick}
                                                        currentPage={this.state.currentPage}
                                                        item={item} index={index}
                                                        onPress={
                                                            () => container.goNext(item, index)
                                                        }/>

                                                }

                                                }
                                            />
                                            {
                                                this.state.listSearch.length > 0 ?
                                                    <View
                                                        style={{

                                                            position: "absolute",
                                                            top: 0,
                                                            height: "95%",
                                                            width: '100%',
                                                            paddingHorizontal: moderateScale(20),
                                                            //marginTop: moderateScale(52),
                                                            // flex: 1,
                                                            zIndex: 9999,

                                                        }}
                                                    >
                                                        <FlatList
                                                            keyboardShouldPersistTaps="handled"
                                                            // ItemSeparatorComponent={
                                                            //     <View style={{
                                                            //         width: '100%',
                                                            //         height: moderateScale(1),
                                                            //         backgroundColor: '#4f4f4f'
                                                            //     }}/>
                                                            // }

                                                            style={{
                                                                backgroundColor: Colors.light2,

                                                                //   marginBottom: moderateScale(50)
                                                            }}

                                                            data={this.state.listSearch}
                                                            //data={[1,2,3,4]}
                                                            //data={dataList}
                                                            keyExtractor={(item, index) => item.id}

                                                            renderItem={({item, index}) =>
                                                                <View style={{}}>
                                                                    {

                                                                        <TouchableOpacity
                                                                            activeOpacity={.9}
                                                                            onPress={() => {
                                                                                this.setState({
                                                                                        // addressMap: item.Address,
                                                                                        listSearch: [],
                                                                                        textInputSearch: ''
                                                                                    },
                                                                                    () => {
                                                                                        let idx = dataList.findIndex(obj => obj.id === item.id);
                                                                                        this.goNext(item, idx)
                                                                                    })

                                                                            }
                                                                            }
                                                                            style={{
                                                                                backgroundColor: Colors.white,
                                                                                marginVertical: moderateScale(4),
                                                                                padding: moderateScale(6),
                                                                                // backgroundColor: Colors.light,
                                                                                // width: "100%",
                                                                                //         flex: 1,
                                                                                marginHorizontal: moderateScale(10),
                                                                                //  alignItems: 'center'
                                                                                //  marginVertical: moderateScale(2),
                                                                                // padding: moderateScale(6)
                                                                            }}>

                                                                            <HMTextView
                                                                                // noFont={false}
                                                                                //  text={item.place_name}
                                                                                text={item.name ? item.name : item.subjects_tks_subject}
                                                                                //  text={"dghd"}
                                                                                numberOfLines={1}
                                                                                style={{
                                                                                    fontSize: moderateScale(14),
                                                                                    // textAlign: 'right',
                                                                                    color: Colors.colorDark,
                                                                                    marginVertical: moderateScale(1)
                                                                                }}/>
                                                                            {/*     <View style={{
                                                                                width: '90%',
                                                                                alignSelf: 'center',
                                                                                marginTop: moderateScale(2),
                                                                                marginBottom: moderateScale(4),
                                                                                height: moderateScale(1),
                                                                                backgroundColor: Colors.light
                                                                            }}/>*/}
                                                                        </TouchableOpacity>
                                                                    }


                                                                </View>
                                                            }

                                                        />
                                                    </View>
                                                    :
                                                    null
                                            }
                                        </View>
                                        :
                                        null
                                }
                                {/*       </View>
                                </ScrollView>*/}


                                <View
                                    style={[this.state.currentPage === 0 ? {
                                        position: 'absolute',
                                        flex: 1,
                                        // height:'100%',
                                        // alignContent: 'center',
                                        // alignItems: 'center',
                                        //  justifyContent: 'center',

                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.01)',
                                        zIndex: 999
                                    } : {display: 'none'}]}>


                                    <ShowMap
                                        //  title={item.type == 10?"آدرس محل زندگی خودرا انتخاب نماید":null}
                                        onclickPin={() => {
                                            let i = this.state.currentPage;
                                            this.setState({listMenu: []},
                                                () => {
                                                    this.setState({
                                                            typeButton: "next",
                                                            listSearch: [],
                                                            textInputSearch: '',
                                                            currentPage: i + 1,
                                                            listMenu: this.selectListInFlatlist(i)

                                                        }
                                                        , () => {
                                                            let indx = 0;
                                                            switch (i) {
                                                                case 0:
                                                                    indx = this.state.indexSelectedArray1
                                                                    break;

                                                                case 1:
                                                                    indx = this.state.indexSelectedArray1Sub
                                                                    break;
                                                            }
                                                            this.goToIndex(indx)
                                                        }
                                                    )
                                                }
                                            )

                                            // this.setState({
                                            //         typeButton: "next",
                                            //         listSearch: [],
                                            //         textInputSearch: '',
                                            //         currentPage: this.state.currentPage + 1
                                            //     }
                                            //     , () => {
                                            //
                                            //     }
                                            // )
                                        }}
                                        type={"layout"}
                                        // myLocation

                                        position={position ?
                                            position :
                                            {coords: {latitude: this.state.lat, longitude: this.state.long,}}
                                        }
                                        textInputAddress={this.state.address}
                                        changeLatLong={(data) => {
                                            if (data && data.coords)
                                                this.setState({lat: data.coords.latitude, long: data.coords.longitude},

                                                    () => {
                                                        //alert(this.state.address)
                                                    }
                                                )
                                            else if (data)
                                                this.setState({lat: data.latitude, long: data.longitude},

                                                    () => {
                                                        //alert(this.state.address)
                                                    }
                                                )
                                        }}

                                        onChangeText={(text) => {
                                            this.setState({address: text},

                                                () => {
                                                    //alert(this.state.address)
                                                }
                                            )
                                        }}
                                    />
                                </View>

                                {
                                    item.type == 10 ?
                                        null
                                        :
                                        <View
                                            style={[this.state.currentPage === CountSteps - 2 ? {
                                                position: 'absolute',
                                                flex: 1,
                                                // height:'100%',
                                                // alignContent: 'center',
                                                // alignItems: 'center',
                                                //  justifyContent: 'center',

                                                top: 0,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                backgroundColor: 'rgba(0,0,0,0.01)',
                                                zIndex: 999
                                            } : {display: 'none'}]}>
                                            {/*    <View
                                            style={{
                                                marginHorizontal: moderateScale(8),
                                                alignItems: 'center',
                                                justifyContent: 'center',

                                                flexDirection: 'row'
                                            }}>

                                            <View

                                                style={{width: typeExport.WIDTH / 2 - moderateScale(10)}}>
                                                <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        alignItems: 'center', justifyContent: 'center'
                                                    }}>
                                                        <View
                                                            style={{
                                                                position: 'relative',
                                                                paddingVertical: moderateScale(10),
                                                                height: typeExport.WIDTH / 2 - moderateScale(45),
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            {
                                                                // this.state.ShowImage ?
                                                                this.state.pathImage !== null ?
                                                                    <View
                                                                        style={{
                                                                            position: 'relative',
                                                                            //backgroundColor: '#eeba0d',
                                                                            width: typeExport.WIDTH / 2 - moderateScale(10),
                                                                            height: typeExport.WIDTH / 2 - moderateScale(45)
                                                                        }}>


                                                                        <Lightbox
                                                                            renderContent={() => (
                                                                                <View style={{
                                                                                    width: typeExport.WIDTH,
                                                                                    height: typeExport.HEIGHT
                                                                                }}>
                                                                                    <Image
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            resizeMode: 'contain'
                                                                                        }}
                                                                                        // source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                                                        source={{uri: this.state.pathImage}}

                                                                                    />
                                                                                </View>
                                                                            )}>
                                                                            <Image
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    resizeMode: 'contain',
                                                                                    backgroundColor: Colors.black
                                                                                }}
                                                                                //source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                                                source={{uri: this.state.pathImage}}
                                                                            />
                                                                        </Lightbox>


                                                                        <TouchableOpacity
                                                                            onPress={() => {
                                                                                //this.setState({ShowImage: false})
                                                                                this.setState({pathImage: null,})
                                                                                // this.onShow("SelectModal")
                                                                            }}

                                                                            style={{
                                                                                width: moderateScale(32),
                                                                                height: moderateScale(32),
                                                                                backgroundColor: '#ee005b',
                                                                                position: 'absolute',
                                                                                borderRadius: moderateScale(16),
                                                                                margin: moderateScale(4),
                                                                                top: 0,
                                                                                left: 0,
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center'
                                                                            }}>
                                                                            <Icon name={"remove"}


                                                                                  style={{
                                                                                      textAlign: 'center',
                                                                                      //alignSelf: 'flex-end',
                                                                                      color: Colors.white,
                                                                                      // width: moderateScale(32),
                                                                                      // height: moderateScale(32),
                                                                                      fontSize: moderateScale(22)
                                                                                  }}/>
                                                                        </TouchableOpacity>
                                                                    </View>
                                                                    :
                                                                    <TouchableOpacity
                                                                        onPress={() => {
                                                                            this.onShow("selectImage")

                                                                            //this.setState({ShowImage: true})
                                                                        }}

                                                                        style={{

                                                                            position: 'absolute',
                                                                            paddingVertical: moderateScale(10),
                                                                            //backgroundColor: '#96a7ee',
                                                                            //  width: moderateScale(40),
                                                                            // height: moderateScale(40),
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}
                                                                    >
                                                                        <Icon name={"md-images"} style={{
                                                                            width: moderateScale(40),
                                                                            height: moderateScale(40),
                                                                            textAlign: 'center',
                                                                            //alignSelf: 'flex-end',
                                                                            color: Colors.gray,
                                                                            //width: moderateScale(32),
                                                                            // height: moderateScale(32),
                                                                            fontSize: moderateScale(40)
                                                                        }}/>

                                                                        <HMTextView
                                                                            text={i18n.t('constant.Add_photo')}
                                                                            style={{
                                                                                alignSelf: 'center',
                                                                                //  marginRight: moderateScale(6),
                                                                                // margin: moderateScale(6),
                                                                                textAlign: 'center',
                                                                                color: Colors.colorDarkText,
                                                                                fontSize: moderateScale(14),
                                                                            }}/>


                                                                    </TouchableOpacity>

                                                            }


                                                        </View>
                                                    </CardItem>
                                                </Card>
                                            </View>
                                            <View style={{width: moderateScale(4)}}/>
                                            <View


                                                style={{width: typeExport.WIDTH / 2 - moderateScale(10)}}>
                                                <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        alignItems: 'center', justifyContent: 'center'
                                                    }}>
                                                        <View
                                                            style={{
                                                                position: 'relative',
                                                                paddingVertical: moderateScale(10),
                                                                height: typeExport.WIDTH / 2 - moderateScale(45),
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >

                                                            {
                                                                this.state.ShowVideo ?
                                                                    <View style={{
                                                                        position: 'relative',
                                                                        //backgroundColor: '#eeba0d',
                                                                        width: typeExport.WIDTH / 2 - moderateScale(10),
                                                                        height: typeExport.WIDTH / 2 - moderateScale(45)
                                                                    }}>
                                                                        <Lightbox
                                                                            renderContent={() => (
                                                                                <View style={{
                                                                                    width: typeExport.WIDTH,
                                                                                    height: typeExport.HEIGHT
                                                                                }}>

                                                                                    <VideoPlayer
                                                                                        ref={ref => this.videoPlayerRef = ref}

                                                                                        rotate={true}   // use this prop to rotate video if it captured in landscape mode iOS only
                                                                                        source={this.state.pathVideo}

                                                                                        style={{
                                                                                            //backgroundColor: 'black',
                                                                                            flex: 1,
                                                                                        }}
                                                                                        resizeMode={VideoPlayer.typeExport.resizeMode.CONTAIN}
                                                                                        onChange={({nativeEvent}) => {
                                                                                        }} // get Current time on every second
                                                                                    />

                                                                                </View>
                                                                            )}>

                                                                            <Image
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    //resizeMode: 'contain'
                                                                                    //
                                                                                    resizeMode: 'stretch'
                                                                                }}
                                                                                //    source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                                                //  source={{uri: `data:image/png;base64,${this.state.pathImageVideo}`}}
                                                                                source={this.state.pathImageVideo}
                                                                            />
                                                                        </Lightbox>

                                                                        <TouchableOpacity
                                                                            onPress={() => {
                                                                                this.setState({ShowVideo: false})
                                                                            }}

                                                                            style={{
                                                                                width: moderateScale(32),
                                                                                height: moderateScale(32),
                                                                                backgroundColor: '#ee005b',
                                                                                position: 'absolute',
                                                                                borderRadius: moderateScale(16),
                                                                                margin: moderateScale(4),
                                                                                top: 0,
                                                                                left: 0,
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center'
                                                                            }}>
                                                                            <Icon name={"remove"} style={{
                                                                                textAlign: 'center',
                                                                                //alignSelf: 'flex-end',
                                                                                color: Colors.white,
                                                                                // width: moderateScale(32),
                                                                                // height: moderateScale(32),
                                                                                fontSize: moderateScale(22)
                                                                            }}/>
                                                                        </TouchableOpacity>
                                                                    </View>
                                                                    :
                                                                    <TouchableOpacity

                                                                        onPress={() => {
                                                                            this.onShow("selectVideo")

                                                                            //this.setState({ShowImage: true})
                                                                        }}
                                                                        style={{

                                                                            paddingVertical: moderateScale(10),
                                                                            //backgroundColor: '#96a7ee',
                                                                            //  width: moderateScale(40),
                                                                            //height: moderateScale(40),
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}
                                                                    >

                                                                        <Icon name={"md-videocam"} style={{
                                                                            width: moderateScale(40),
                                                                            height: moderateScale(40),
                                                                            textAlign: 'center',
                                                                            //alignSelf: 'flex-end',
                                                                            color: Colors.gray,
                                                                            // width: moderateScale(32),
                                                                            // height: moderateScale(32),
                                                                            fontSize: moderateScale(40)
                                                                        }}/>

                                                                        <HMTextView
                                                                            text={i18n.t('constant.Add_video')}
                                                                            style={{
                                                                                alignSelf: 'center',
                                                                                //  marginRight: moderateScale(6),
                                                                                // margin: moderateScale(6),
                                                                                textAlign: 'center',
                                                                                color: Colors.colorDarkText,
                                                                                fontSize: moderateScale(14),
                                                                            }}/>


                                                                    </TouchableOpacity>
                                                            }


                                                        </View>
                                                    </CardItem>
                                                </Card>
                                            </View>

                                        </View>

                                        <View
                                            style={{
                                                marginHorizontal: moderateScale(8),
                                                //alignItems: 'center',
                                                // justifyContent: 'center',

                                                flexDirection: 'row'
                                            }}>

                                            <View

                                                style={{width: typeExport.WIDTH / 2 - moderateScale(10)}}>
                                                <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        alignItems: 'center', justifyContent: 'center'
                                                    }}>
                                                        <View
                                                            style={{
                                                                position: 'relative',
                                                                paddingVertical: moderateScale(10),
                                                                height: typeExport.WIDTH / 2 - moderateScale(45),
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            {
                                                                // this.state.ShowImage ?
                                                                this.state.ShowAudio ?
                                                                    <View
                                                                        style={{
                                                                            position: 'relative',
                                                                            //backgroundColor: '#eeba0d',
                                                                            width: typeExport.WIDTH / 2 - moderateScale(10),
                                                                            height: typeExport.WIDTH / 2 - moderateScale(45)
                                                                        }}>

                                                                        <TouchableOpacity
                                                                            onPress={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        playState: 'paused',
                                                                                        visibleModal: "selectaudio",
                                                                                        Modalcategory: true,
                                                                                    },
                                                                                    () => {
                                                                                        // this.onShow("selectaudio")

                                                                                        this._play()

                                                                                    }
                                                                                )
                                                                            }}
                                                                            style={{
                                                                                // width: "100%",
                                                                                //height: "100%",
                                                                                //resizeMode: 'contain'
                                                                                //
                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                left: 0,
                                                                                right: 0,
                                                                                bottom: 0,
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                backgroundColor: Colors.blackLight,
                                                                            }}>
                                                                            <Image
                                                                                style={{
                                                                                    width: "30%",
                                                                                    height: "30%",
                                                                                    //resizeMode: 'contain'
                                                                                    //
                                                                                    // position: 'absolute',
                                                                                    // top: 0,
                                                                                    // left: 0,
                                                                                    // right: 0,
                                                                                    // bottom: 0,
                                                                                    resizeMode: 'stretch',
                                                                                    tintColor: Colors.white
                                                                                }}
                                                                                //    source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                                                //  source={{uri: `data:image/png;base64,${this.state.pathImageVideo}`}}
                                                                                source={PathFile.image.img_speaker}
                                                                            />

                                                                        </TouchableOpacity>


                                                                        <TouchableOpacity
                                                                            onPress={() => {

                                                                                this._refreshAudio()

                                                                                // this.setState({audioPath: null,})
                                                                                // this.onShow("SelectModal")
                                                                            }}

                                                                            style={{
                                                                                width: moderateScale(32),
                                                                                height: moderateScale(32),
                                                                                backgroundColor: '#ee005b',
                                                                                position: 'absolute',
                                                                                borderRadius: moderateScale(16),
                                                                                margin: moderateScale(4),
                                                                                top: 0,
                                                                                left: 0,
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center'
                                                                            }}>
                                                                            <Icon name={"remove"} style={{
                                                                                textAlign: 'center',
                                                                                //alignSelf: 'flex-end',
                                                                                color: Colors.white,
                                                                                // width: moderateScale(32),
                                                                                // height: moderateScale(32),
                                                                                fontSize: moderateScale(22)
                                                                            }}/>
                                                                        </TouchableOpacity>
                                                                    </View>
                                                                    :
                                                                    <TouchableOpacity
                                                                        onPress={() => {
                                                                            this.onShow("selectaudio")

                                                                            //this.setState({ShowImage: true})
                                                                        }}

                                                                        style={{


                                                                            position: 'absolute',
                                                                            paddingVertical: moderateScale(10),
                                                                            //backgroundColor: '#96a7ee',
                                                                            //  width: moderateScale(40),
                                                                            // height: moderateScale(40),
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}
                                                                    >
                                                                        <Icon name={"ios-mic"} style={{
                                                                            width: moderateScale(40),
                                                                            height: moderateScale(40),
                                                                            textAlign: 'center',
                                                                            //alignSelf: 'flex-end',
                                                                            color: Colors.gray,
                                                                            //width: moderateScale(32),
                                                                            // height: moderateScale(32),
                                                                            fontSize: moderateScale(40)
                                                                        }}/>

                                                                        <HMTextView
                                                                            text={i18n.t('constant.Add_audio')}
                                                                            style={{
                                                                                alignSelf: 'center',
                                                                                //  marginRight: moderateScale(6),
                                                                                // margin: moderateScale(6),
                                                                                textAlign: 'center',
                                                                                color: Colors.colorDarkText,
                                                                                fontSize: moderateScale(14),
                                                                            }}/>


                                                                    </TouchableOpacity>

                                                            }


                                                        </View>
                                                    </CardItem>
                                                </Card>
                                            </View>

                                        </View>*/}
                                            {/*<HMFiles stateParent={this.state} func={container._setDataFiles}*/}
                                            {/*_setStateData={container._setStateData}/>*/}
                                            <HMFilesTest
                                                stateParent={this.state}
                                                _setStateData={this._setStateData}
                                                // _setStateDataParent={container.props._setStateData}
                                                SizeBox={3}
                                                styleRoot2={{
                                                    flexDirection: 'row',
                                                    flexWrap: 'wrap',
                                                    width: "100%",

                                                    // flexGrow: 1,
                                                    //  backgroundColor: "#ee04d0",
                                                    alignItems: "flex-start"

                                                }}
                                                //clearState={this.clearState}

                                            />

                                        </View>

                                }

                                {


                                    <View
                                        style={[this.state.currentPage === CountSteps - 1 ? {
                                            position: 'absolute',
                                            flex: 1,
                                            // height:'100%',
                                            // alignContent: 'center',
                                            // alignItems: 'center',
                                            //  justifyContent: 'center',

                                            top: 0,
                                            bottom: 0,
                                            right: 0,
                                            left: 0,
                                            backgroundColor: 'rgba(0,0,0,0.01)',
                                            zIndex: 999
                                        } : {display: 'none'}]}>

                                        {
                                            typeComponent ?
                                                null :
                                                <TouchableOpacity
                                                    onPress={() => this.setState({

                                                        //     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,
                                                        checked: !this.state.checked,
                                                    })}

                                                    style={{
                                                        flexDirection: "row",
                                                        // alignSelf: "flex-end",
                                                        marginHorizontal: moderateScale(6),
                                                        marginVertical: moderateScale(8)
                                                    }}>
                                                    <View style={{
                                                        width: moderateScale(24),
                                                        height: moderateScale(24),
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: moderateScale(12),
                                                        alignItems: 'center', justifyContent: 'center',
                                                        borderWidth: moderateScale(1),
                                                        borderColor: Colors.gray

                                                    }}>
                                                        <Image
                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                            source={(PathFile.image.Check)}
                                                            //resizeMode="stretch"
                                                            style={[!this.state.checked ? {
                                                                width: moderateScale(0),
                                                                height: moderateScale(0),
                                                            } : {


                                                                width: moderateScale(18),
                                                                height: moderateScale(18),
                                                            }]}/>
                                                    </View>
                                                    {/*  <CheckBox
                                                center
                                                //  style={{width:moderateScale(20),height:moderateScale(20),textAlign:'center'}}
                                                color={!this.state.checked ? Colors.colorDark : Colors.red}
                                                checked={this.state.checked} onPress={(check) => {


                                                this.setState({
                                                    checked: !this.state.checked,
                                                })


                                            }}/>*/}
                                                    <View style={{width: moderateScale(8)}}/>
                                                    <View
                                                    >
                                                        <HMTextView
                                                            //text="اطلاعاتم بصورت محرمانه باشد"
                                                            text={"واحد اجرا اطلاعات من را نبیند"}
                                                            style={{color: !this.state.checked ? Colors.colorDark : Colors.green}}
                                                        />

                                                    </View>

                                                </TouchableOpacity>
                                        }


                                        <View
                                            style={{
                                                marginHorizontal: moderateScale(8),
                                                height: moderateScale(80),
                                                marginVertical: moderateScale(4)
                                            }}>
                                            {/*<Card>
                                                <CardItem cardBody style={{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                }}>
                                                    <View
                                                        style={{paddingVertical: moderateScale(10)}}
                                                    >

                                                    </View>
                                                </CardItem>
                                            </Card>*/}
                                            <HMTextView
                                                type={"bold"}
                                                //text="اطلاعاتم بصورت محرمانه باشد"
                                                text={"آدرس خود را تکمیل نمایید"}
                                                style={{color: Colors.blackLight, fontSize: moderateScale(14)}}
                                            />
                                            <HMTextInput
                                                _multiline
                                                //numberOfLines={2}
                                                value={this.state.address}
                                                _height={moderateScale(80)}
                                                onChangeText={text => {
                                                    this.setState({address: text})
                                                }}

                                                //       keyboardType="numeric"
                                                placeholder={i18n.t('constant.PlaceholderAddress')}
                                                style={{
                                                    // width: "90%",

                                                    fontSize: moderateScale(14)
                                                }} underlineColorAndroid="transparent"/>
                                        </View>

                                        <View style={{marginHorizontal: moderateScale(8)}}>
                                            {/* <Card>
                                                <CardItem cardBody style={{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                }}>
                                                    <View
                                                        style={{paddingVertical: moderateScale(10)}}
                                                    >


                                                    </View>
                                                </CardItem>
                                            </Card>*/}

                                            <HMTextInput
                                                value={this.state.description}

                                                onChangeText={text => {
                                                    this.setState({description: text})
                                                }}
                                                _multiline
                                                _height={moderateScale(100)}
                                                //   keyboardType="numeric"
                                                placeholder={i18n.t('constant.PlaceholderDesc')}
                                                style={{
                                                    // width: "90%",
                                                    // height:moderateScale(100),
                                                    fontSize: moderateScale(14),

                                                }} underlineColorAndroid="transparent"
                                                styleInput={{height: moderateScale(80)}}

                                                // textCenter={'center'}
                                            />
                                        </View>
                                    </View>

                                }


                            </View>

                            <View
                                style={{
                                    width: '100%',
                                    height: moderateScale(42),
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(3)
                                }}>

                                {


                                    <View
                                        style={{
                                            width: '100%',
                                            height: moderateScale
                                            (42),
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: moderateScale(3)
                                        }}
                                    >
                                        <TouchableOpacity
                                            onPress={() => {
                                                // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                this.goBack();
                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)

                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Back')} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>

                                        <View style={{width: moderateScale(8)}}/>
                                        <TouchableOpacity

                                            onPress={() => {
                                                //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
                                                if (this.state.currentPage == 0)
                                                    Keyboard.dismiss()
                                                if (this.state.currentPage <= CountSteps - 2) {
                                                    // indexSelectedArray1: -1,
                                                    //     itemSelectedArray1: null,
                                                    //
                                                    //     itemSelectedArray1Sub: null,
                                                    //     indexSelectedArray1Sub: -1,
                                                    //
                                                    //     indexSelectedArray2: -1,
                                                    //     itemSelectedArray2: null,
                                                    //
                                                    //
                                                    //     indexSelectedArray2Sub: -1,
                                                    //     itemSelectedArray2Sub: null,

                                                    if (this.state.currentPage == 1 && this.state.indexSelectedArray1 == -1)
                                                        HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                                // {text: 'Ask me later', onPress: () => {}},
                                                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                {
                                                                    text: i18n.t('constant.ok'), onPress: () => {
                                                                    }
                                                                },
                                                            ],
                                                            {cancelable: true}
                                                        )
                                                    else if (this.state.currentPage == 2 && this.state.indexSelectedArray1Sub == -1) {
                                                        HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                                // {text: 'Ask me later', onPress: () => {}},
                                                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                {
                                                                    text: i18n.t('constant.ok'), onPress: () => {
                                                                    }
                                                                },
                                                            ],
                                                            {cancelable: true}
                                                        )
                                                    }

                                                    /*    else if (this.state.currentPage == 2 && this.state.indexSelectedArray2 == -1) {
                                                            HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                                    // {text: 'Ask me later', onPress: () => {}},
                                                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                    {
                                                                        text: i18n.t('constant.ok'), onPress: () => {
                                                                        }
                                                                    },
                                                                ],
                                                                {cancelable: true}
                                                            )
                                                        } else if (this.state.currentPage == 3 && this.state.indexSelectedArray2Sub == -1) {
                                                            HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                                    // {text: 'Ask me later', onPress: () => {}},
                                                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                    {
                                                                        text: i18n.t('constant.ok'), onPress: () => {
                                                                        }
                                                                    },
                                                                ],
                                                                {cancelable: true}
                                                            )
                                                        } */

                                                    else {
                                                        let i = this.state.currentPage;
                                                        this.setState({listMenu: []},
                                                            () => {
                                                                this.setState({
                                                                        typeButton: "next",
                                                                        listSearch: [],
                                                                        textInputSearch: '',
                                                                        currentPage: i + 1,
                                                                        listMenu: this.selectListInFlatlist(i)

                                                                    }
                                                                    , () => {
                                                                        let indx = 0;
                                                                        switch (i) {
                                                                            case 0:
                                                                                indx = this.state.indexSelectedArray1
                                                                                break;

                                                                            case 1:
                                                                                indx = this.state.indexSelectedArray1Sub
                                                                                break;
                                                                        }
                                                                        this.goToIndex(indx)
                                                                    }
                                                                )
                                                            }
                                                        )

                                                    }
                                                } else {
                                                    this.setData()
                                                }


                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)
                                            }}>
                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={textButtonNext} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>
                                    </View>

                                }

                            </View>

                        </View>

                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkMobile(this.state.mobile)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading || this.props.isLoadingSet || this.state.isLoadingCompress ?
                                <DialogLoadingCustomize
                                    text={this.state.isLoadingCompress ? "درحال کاهش حجم فایل" : null}
                                />
                                :
                                null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value)
            },
            () => {
            })
    }

    _setDataFiles(name, data) {
        container.setState({[name]: data});
    }

    onChangecategory(index, data) {

        container.setState({
            Category: {value: data.name, id: data.id},
            CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},
            arrayCategoryType: data.subjects,
            dataSourcearrayCategoryType: data.subjects,
            visibleModal: ''
        })
    }


    onChangeCategoryType(index, data) {
        container.setState({
            CategoryType: {value: data.subjects_tks_subject, id: data.subjectsid},
            visibleModal: ''
            //CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},

            // arrayCategoryType: data.CategoryType

        })
    }


    changeLatLong(data) {
        this.setState({lat: data.latitude, long: data.longitude});
    }

    _changeTextAddress(text) {
        this.setState({address: text});
    }


    _changeTextDesc(text) {
        this.setState({desc: text});
    }


    async setData() {
        let {token} = store.getState().reducerSplashGetAllData
        let {typeComponent} = this.props.route.params
        let _params = this.props.route.params;

        let item = JSON.parse(_params.item);
        let data = JSON.parse(_params.data);
        let position = JSON.parse(_params.position);

        if (store.getState().reducerSplashGetAllData.Connection || typeComponent) {
            let paramss = {
                "_operation": typeComponent ? typeExport._Shahrdar : typeExport._Contacts,
                "mode": "SaveTickets",
                "lang": i18n.locale,
                "token": token,
                "type": item.type,
                "typepm": data.typepm,
                "image": this.state.pathImage,
                "video": this.state.pathVideo,
                "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
                "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
                "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,
                "arrImage": this.state.arrImage,
                /*         "category": this.state.Category.value,
                         "subject": this.state.CategoryType.value,
                         "subjectid": this.state.CategoryType.id,*/
                "category": this.state.itemSelectedArray1.name,
                "subject": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjects_tks_subject ? this.state.itemSelectedArray1Sub.subjects_tks_subject : this.state.itemSelectedArray1.name,
                "subjectid": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjectsid ? this.state.itemSelectedArray1Sub.subjectsid : this.state.itemSelectedArray1.id,
                "description": this.state.description,
                "address": this.state.address,
                "longitude": this.state.long,
                "latitude": this.state.lat,
                "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                "private": this.state.checked ? "1" : "0",
                "typeComponent": typeComponent,
                //"token_fb": this.props.DataSplashScreen.token_fb,
            };
            // if (this.state.Category.id === 0) {
            //     HMAlert(i18n.t('constant.message'), i18n.t('constant.selectCategory'), [
            //             // {text: 'Ask me later', onPress: () => {}},
            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
            //             {text: i18n.t('constant.ok'), onPress: () => {}},
            //         ],
            //         {cancelable: true}
            //     )
            // } else {
            //     if (this.state.CategoryType.id === 0) {
            //         HMAlert(i18n.t('constant.message'), i18n.t('constant.selectCategoryType'), [
            //                 // {text: 'Ask me later', onPress: () => {}},
            //                 // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
            //                 {text: i18n.t('constant.ok'), onPress: () => {}},
            //             ],
            //             {cancelable: true}
            //         )
            //     } else {
            //         //   let {mobile, password} = this.state;


            this.props.callService(
                typeComponent ? typeExport._baseUrlSainaShahrdar : typeExport.urlGetSubmitRequest,
                paramss,
                typeExport.TypeSetSubmitRequestScreen22,
                "POST",
                token
            );
            //this.GoScreen()
            //     }
            // }
        }
        else {
            let listMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApplyOffline + item.type);
            let data = {
                "_operation": typeExport._Contacts,
                "mode": "SaveTickets",
                "lang": i18n.locale,
                "token": token,
                "type": item.type,
                "typepm": data.typepm,
                "image": this.state.pathImage,
                "arrImage": this.state.arrImage,

                "video": this.state.pathVideo,
                "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
                "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
                "durationVoice": this.state.ShowAudio ? (this.state.currentTime) : null,
                // "category": this.state.Category.value,
                // "subject": this.state.CategoryType.value,
                // "subjectid": this.state.CategoryType.id,
                "category": this.state.itemSelectedArray1.name,
                "subject": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjects_tks_subject ? this.state.itemSelectedArray1Sub.subjects_tks_subject : this.state.itemSelectedArray1.name,
                "subjectid": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjectsid ? this.state.itemSelectedArray1Sub.subjectsid : this.state.itemSelectedArray1.id,
                "description": this.state.description,
                "address": this.state.address,
                "longitude": this.state.long,
                "latitude": this.state.lat,
                "index": (listMyApply != null && listMyApply.length > 0) ? listMyApply.length + 1 : 1,
                "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                "private": this.state.checked ? "1" : "0",
                "typeComponent": typeComponent,


                //"token_fb": this.props.DataSplashScreen.token_fb,
            };


            if (listMyApply != null && listMyApply.length > 0) {
                listMyApply.push(data)

            } else {
                listMyApply = [];
                listMyApply.push(data)
            }


            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApplyOffline + item.type, listMyApply)
            // this.props.callServiceListNotSendMyApply(listMyApply)
            store.dispatch(serviceActionListNotSendMyApply(listMyApply));
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.RequestSuccessfullyRegistered'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                            NavigationService.BackTo(1)
                            //  NavigationService.navigatereset("ApplyScreen", {item: item})
                        }
                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                        , style: 'cancel'
                    },

                ],
                {cancelable: true}
            )


        }


    }

    _setStateData(object) {
        container.setState(object);
    }
}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressText: {

        paddingTop: moderateScale(50),
        fontSize: moderateScale(50),
        color: "#fff",
    },
    progressTextPlay: {
        paddingTop: moderateScale(25),
        fontSize: moderateScale(25),
        color: "#fff"
    },
    button: {
        padding: moderateScale(20)
    },
    disabledButtonText: {
        color: '#eee'
    },
    buttonText: {
        fontSize: moderateScale(20),
        color: "#fff"
    },
    activeButtonText: {
        fontSize: moderateScale(20),
        color: "#B81F00"
    }
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});
